// extracted by mini-css-extract-plugin
module.exports = {"C_section":"C_C_section__gPcaz"};